import * as React from "react"
import Profit from "../images/profit.inline.svg"

const MarathonProfit = ({ marathonProfitRef, isAboutMarathonPlay }) => (
  <div id="profit" ref={marathonProfitRef} className="blog-content">
    <div className="container">
      <div className="article-block w-richtext">
        <Profit
          style={{
            width: "100px",
            height: "100px",
          }}
        />
        <h2>Что Вы получите?</h2>
        <ul>
          <li>
            Чувство <b>легкости и комфорта</b>
          </li>
          <li>
            Избавитесь от лишних <b>кг и оттёков</b>
          </li>
          <li>
            Научитесь <b>правильно</b> и <b>сбалансированно</b> питаться
          </li>
          <li>
            Приобретёте сильнейшую <b>мотивацию</b> и толчок продолжать
            совершенствоваться и не останавливаться на достигнутом
          </li>
          <li>
            Вы <b>научитесь</b> любить и принимать себя
          </li>
          <li>
            Новые <b>знакомства и общение</b> с единомышленниками. Поддержка
            обеспечена <b>24/7</b>
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default MarathonProfit
